<script setup lang="ts">
    import { computed, watch, onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { useStrategyFixPageQueryV1 } from '@Quest/Strategies/queries-vue-composables'
    import { useTriggerMetricUpdatesCommandV1 } from '@Quest/Strategies/commands-vue-composables'
    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"

    const route = useRoute()
    const router = useRouter()

    const workspaceId = computed(() => Number(route.params.workspaceId))
    const strategyId = computed(() => String(route.params.strategyId))

    const {
        runStrategyFixPageQueryV1,
        modelStrategyFixPageQueryV1: rm
    } = useStrategyFixPageQueryV1(workspaceId, strategyId)

    const {
        invokeTriggerMetricUpdatesCommandV1,
        invokingTriggerMetricUpdatesCommandV1,
        errorTriggerMetricUpdatesCommandV1,
        succeedTriggerMetricUpdatesCommandV1
    } = useTriggerMetricUpdatesCommandV1(workspaceId, strategyId);


    onMounted(() =>
    {
        document.title = "Enterprise Fix | TransparentChoice";
        runStrategyFixPageQueryV1();
    })


    watch(errorTriggerMetricUpdatesCommandV1, (err) =>
    {
        if (err)
        {
            alert(err)
        }
    })

    watch(succeedTriggerMetricUpdatesCommandV1, (succeeded) =>
    {
        alert('Done');
    })
</script>

<template>
    <div>
        <CorporateNavigation ActivePage="dashboard" />

        <div v-if="rm" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Warning: Advanced Operations Ahead</h4>
                <p>
                    This page provides access to advanced troubleshooting commands that can significantly impact customer data and system functionality.
                    <strong>If you are unsure about a command, do not proceed.</strong> Consult the documentation or seek guidance before making changes.
                </p>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <h3 class="card-title">Update Metrics</h3>
                            <p class="card-text">
                                Metric updates are automatically triggered by the system when data changes.
                                <strong>Use this only if you suspect an issue due to a bug.</strong>
                            </p>
                            <p class="card-text">
                                Triggering a metric update requires updating all enterprise projects.
                                <strong>Avoid running this command during peak hours</strong> to reduce the risk of disrupting active users.
                            </p>

                            <button class="btn btn-outline-secondary btn-block" 
                                    @click="invokeTriggerMetricUpdatesCommandV1" 
                                    :disabled="invokingTriggerMetricUpdatesCommandV1">
                                Trigger Metrics Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


